import React, { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { VisitTrackingProvider } from "../../context/VisitTrackingContext";
import { getUserData } from "../../services/apiService";
import {
  needsCredentialChange,
  needsTermsAcceptance,
} from "../../utils/credentialGateUtils";
import {
  isSponsorCroPathAllowed,
  isSponsorCroSession,
  resolveSponsorCroLandingRoute,
} from "../../utils/sponsorCroAccess";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import VisitTracker from "./VisitTracker";
import "./Sidebar.scss";
import "./Header.scss";
import "./Layout.scss";

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const userData = getUserData();
    if (needsTermsAcceptance(userData)) {
      navigate("/accept-terms", { replace: true });
      return;
    }
    if (needsCredentialChange(userData)) {
      navigate("/change-credentials-required", { replace: true });
      return;
    }
    if (
      isSponsorCroSession(userData) &&
      !isSponsorCroPathAllowed(location.pathname, userData)
    ) {
      navigate(resolveSponsorCroLandingRoute(userData), { replace: true });
    }
  }, [navigate, location.pathname]);

  return (
    <VisitTrackingProvider>
      <VisitTracker />
      <div className="d-flex flex-column vh-100 min-h-0">
        <Header />
        <div className="layout-content-wrapper d-flex flex-grow-1 min-h-0">
          <Sidebar />
          <div className="flex-grow-1 d-flex flex-column main-content-wrapper min-h-0">
            <main className="flex-grow-1 min-h-0 overflow-auto p-3">
              <Outlet />
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </VisitTrackingProvider>
  );
};

export default Layout;
